import { FileUpload } from '@cinesend/ui-kit'
import useStore from '../../hooks/use_store'
import { useParams } from 'react-router-dom'
import generateSHA256FromImage from '../../helpers/generate_sha256'
import { useSnackbar } from '../../hooks/use_snackbar'

export default function Upload({ assetID, field, assetImage, onNewImageSelected }) {
  const { airlineID, cycleID } = useParams()
  const { updateModel, createModel } = useStore()
  const { addMessage } = useSnackbar()

  // Once an image is picked from the file selector, we either create or update the asset image.
  const startImageUpload = async (file) => {
    let sha256 = null
    try {
      sha256 = await generateSHA256FromImage(file)
    } catch (error) {
      addMessage(`Error generating sha256 for '${file.name}': ${error}`, 'error')
      return
    }

    const data = {
      asset_id: assetID,
      airline_id: airlineID,
      cycle_id: cycleID,
      field_id: field.id,
      size: file.size,
      file_name: file.name,
      mime: file.type,
      sha256,
    }

    if (assetImage) {
      updateModel.mutate(
        {
          endpoint: '/asset-images',
          id: assetImage.id,
          data,
        },
        {
          onSuccess: (res) => uploadToS3(res.data.signed_upload_url, file, res.data.asset_image),
        }
      )
      return
    }
    createModel.mutate(
      {
        endpoint: '/asset-images',
        data,
      },
      {
        onSuccess: (res) => uploadToS3(res.data.signed_upload_url, file, res.data.asset_image),
      }
    )
  }

  const uploadToS3 = (signedUrl, file, assetImage) => {
    // axios adds unnecessary headers
    fetch(signedUrl, {
      body: file,
      method: 'PUT',
      mode: 'cors',
      headers: {
        'Content-Type': file.type,
      },
    })
      .then((res) => {
        updateModel.mutate(
          {
            endpoint: `/asset-images`,
            id: assetImage.id,
            silent: true,
            data: {
              asset_id: assetID,
              cycle_id: cycleID,
              status: 'uploaded',
            },
          },
          {
            onSuccess: () => onNewImageSelected(assetImage),
          }
        )
      })
      .catch((err) => console.log(err))
  }

  return (
    <FileUpload
      className='h-48 w-full'
      accept='.jpg'
      buttonLabel={`Upload ${field.name}`}
      message='Drag and drop your image or click here to upload. Accepted file type: .jpg'
      onFileSelected={startImageUpload}
    />
  )
}
